(function () {
  const initCollapsibleContent = (root = document) => {
    const $sections = root instanceof Element ? $(root).closest(".collapsible-content").length ? $(root).closest(".collapsible-content") : $(root).find(".collapsible-content") : $(".collapsible-content");

    $sections.each(function () {
      const $section = $(this);

      $section.find(".collapsible-content__toggle").each(function () {
        const $toggle = $(this);
        if ($toggle.data("cc-init")) return;
        $toggle.data("cc-init", true);

        $toggle.on("click", function () {
          const $item = $(this).closest(".collapsible-content__item");
          const $itemsContainer = $(this).closest(".collapsible-content__items");
          const $answer = $(this).next(".collapsible-content__answer");

          if (!$item.hasClass("active")) {
            $item.siblings(".collapsible-content__item.active").removeClass("active");
            $item.addClass("active");
            $itemsContainer.find(".collapsible-content__answer").stop().slideUp(300);
            $answer.stop().slideDown(300);
          } else {
            $item.removeClass("active");
            $answer.stop().slideUp(300);
          }
        });
      });

      $section.find(".collapsible-content__item").each(function () {
        const $item = $(this);
        if ($item.data("cc-hover-init")) return;
        $item.data("cc-hover-init", true);

        $item.on("mouseenter", function () {
          const $current = $(this);
          $current.removeClass("collapsible-content__item--opacity");
          $current.siblings().addClass("collapsible-content__item--opacity");
        });

        $item.on("mouseleave", function () {
          const $current = $(this);
          $current.siblings().removeClass("collapsible-content__item--opacity");
        });
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initCollapsibleContent();
  });

  document.addEventListener("shopify:section:load", function (event) {
    const sectionTarget = event.target || (event.detail && event.detail.section);
    if (sectionTarget) {
      initCollapsibleContent(sectionTarget);
    } else {
      initCollapsibleContent();
    }
  });
})();
